const CarBanData = {
  subheading: "UNRIVALLED OWNERSHIP EXPERIENCE",
  title: "Get it all beyond price: Premium, Quality & Value.",
  data: "The new Sonet delivers a wild driving experience that’s reborn to transcend your expectations. Get ready to immerse yourself in the world of unmatched quality, unbeatable value, and unparalleled premium appeal. With a commitment to excellence, the Sonet offers exceptional value-for-money boasting the Lowest Maintenance Cost, Best Total Cost of Ownership and Highest Residual Value in its segment*.​",
  carData: [
    {
      cover:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet20(1).webp?alt=media&token=1d49a82c-24e2-4a39-b14b-2d1ab3130972",
      small:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2F90x90_3.png?alt=media&token=8d5ce4eb-9c33-4d9b-b2e1-7bdc0ea84721",
      title: "Lowest Maintenance in the Segment*",
      desc1: "Petrol - 16% lower than average",
      desc2: "Diesel - 14% lower than average",
    },

    {
      cover:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2F2-d.jpg?alt=media&token=b8291bdb-de0c-4dd7-ad25-1c2d14bf7728",
      small:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2F90x90_2.png?alt=media&token=a2f6801c-9e0c-4581-b894-20102172e094",
      title: "Lowest Total Cost of Ownership",
      desc1: "Segment*-best in diesel",
      desc2: "Second best in petrol",
    },
    {
      cover:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2FDesk-1920x1080.jpg?alt=media&token=7973c169-3985-4b6c-b4a8-869cf6366e23",
      small:
        "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2F90x90_1.png?alt=media&token=78d53348-8f14-4b52-9ac3-01e1984e6229",
      title: "Higher Residual Value ",
      desc1: "Best-in-Segment* ",
      desc2: "3% higher than average",
    },
  ],
};

const banner2Data = {
  imgSrc:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2F1920_10802%20(1).jpg?alt=media&token=88445d66-1195-4259-b8f6-9bb83cc1f016",
  data: [
    {
      title: "Segment-best Safety",
      description:
        "Robust 15-Hi Safety Package as Standard, and Intuitive ADAS Level 1.0",
    },
    {
      title: "Segment-best Convenience",
      description: "360° Camera with Blind View Monitor in cluster",
    },
    {
      title: "New-age Smart",
      description: "Kia Connect with over 70 smart connected car features",
    },
  ],
};

const BannerData = {
  videoUrl:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2Fsonet.mp4?alt=media&token=94d60d22-7e2f-49e7-b7ad-bab6b7c8159d",
  title: "New Sonet",
  subtitle: "The Wild. Reborn.",
  price: "₹7 30 138#",
  features: [
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2Ficon1sonet.webp?alt=media&token=b47219f8-fd81-4577-af8d-a212d3bc93bc",
      text: "ADAS Level 1",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2Ficon2sonet.webp?alt=media&token=65681279-193f-4bcf-bcdd-1a7bae5bdda2",
      text: "360° Camera with Blind View Monitor in cluster",
    },
    {
      imgSrc:
        "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2Ficon3sonet.webp?alt=media&token=beb580d0-2c86-48fc-b4a1-7205d4f6d369",
      text: "Star Map LED Connected Tail Lamps",
    },
  ],
};

const IntroData = {
  heading: "DRIVEN BY INSTINCT.",
  subheading: "Introducing, The new Sonet.",
  description:
    "In a world gone tame, The new Sonet, a subcompact SUV is here to set you free. Chiseled to perfection, raw in power, and loaded with tech, it's built to give you a one-of-a-kind driving experience. So, climb in the new Kia Sonet and let your wild instincts take over.",
  image:
    "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Frange-d.webp?alt=media&token=5a94ea87-8447-4fef-a09d-12ffb2f9f5e6",
};

const InterestDealerData = {
  disclaimer: "",
  register:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2Fregister%20intrest.png?alt=media&token=2c5fb2a2-418b-4399-8994-8e590bd17314",
  dealer:
    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Syros%2FBrochure%20image.png?alt=media&token=5ce8b8e6-2d25-41f1-b458-69aa2bd51a10",
};

const CarouselData = [
  {
    sub: "X-Line",
    title: "The wild experience you can't resist.",
    data: "Presenting the new Sonet X-Line, now wilder than ever. Explore the wild allure of the exclusive Matte Graphite exterior, embracing a cabin experience that defies resistance. Ready to set the stage for envy as you journey through diverse horizons, this subcompact SUV in India is designed to captivate and impress.​​",
    carData: [
      {
        title: "R16 40.56cm (16”) Sporty Crystal Cut Alloy Wheels",
        description:
          "A distinctive design, featuring untamed crystal-cut patterns on a sleek black surface, is the perfect blend of sporty look with performance.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fx3.webp?alt=media&token=53567645-0d79-4230-9b04-dfdfae71230f",
      },
      {
        title:
          "Kia Signature Tiger Nose Grille with Knurled Xclusive Black High Gloss Surround",
        description:
          "Bring out the wild in you with the fierce Kia Signature Tiger Nose grille, while the knurled glossy surround adds a touch of wild charm.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fx3.webp?alt=media&token=53567645-0d79-4230-9b04-dfdfae71230f",
      },
      {
        title: "All Door Power Window One Touch Auto Up/Down with Safety",
        description:
          "Effortlessly control all windows with a single touch while ensuring safety with auto-stop, in case of obstructions.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fx4.webp?alt=media&token=a8046d76-81f6-4ac2-a603-3c77140586af",
      },
      {
        title: "Full Digital Cluster with 26.04cm (10.25') Color LCD MID",
        description:
          "Embrace a futuristic instrument cluster that features a comprehensive and sleek interface to make every journey convenient and immersive.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fx4.webp?alt=media&token=a8046d76-81f6-4ac2-a603-3c77140586af",
      },
    ],
  },
];

const CarouselData1 = [
  {
    sub: "EXTERIOR",
    title: "A dominating stance.",
    data: "The majestic attitude of the new Sonet is sure to make a statement. The reborn new Sonet facelift is designed to look intimidating with a bold new Signature Tiger Nose Grille. The new Sonet, a popular subcompact SUV in India, commands respect and oozes dominance wherever it goes.",
    carData: [
      {
        title: "Electric Sunroof",
        description:
          "Elevate your drive with a sunroof, turning every road trip into a scenic adventure.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F5-d.mp4?alt=media&token=ee460b9d-2dee-4d78-bd33-986b3a6bbfa6",
      },
      {
        title: "Rear Spoiler",
        description:
          "Provides a sporty and dynamic appeal to The Wild Design.​​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fext7.webp?alt=media&token=c7a6ec8a-7695-4cb6-94a2-442fdde20fd3",
      },
      {
        title: "Crown Jewel LED Headlamps and Star Map LED DRLs",
        description:
          "Highlight the all-new bold front and give it a dazzling road presence",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F5-d.mp4?alt=media&token=ee460b9d-2dee-4d78-bd33-986b3a6bbfa6",
      },
      {
        title: "Signature Tiger Nose Grille",
        description:
          "Takes the untamed style quotient to stunning new heights.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fext2.webp?alt=media&token=79c37ea6-9708-4d0e-9dcb-e459789f7c9a",
      },

      {
        title: "Sleek LED Fog Lamps",
        description: "Enhance the overall sleek appeal.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F5-d.mp4?alt=media&token=ee460b9d-2dee-4d78-bd33-986b3a6bbfa6",
      },
      {
        title: "Sporty Aerodynamic Rear Skid Plates with Dark Metallic Accents",
        description: "Adds a sporty edge to the car’s unbridled design appeal.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fext4.webp?alt=media&token=599c2031-792d-46f9-852d-87bad75f0d3b",
      },
      {
        title: "R16 - 40.56 cm (16”) Sporty Crystal Cut Alloy Wheels",
        description:
          "Give your wheels a striking spin as you prowl the streets.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fext8.webp?alt=media&token=e4ef132b-290d-4d9f-8ef4-08fb9fd3ca30",
      },
      {
        title: "Star Map LED Connected Tail Lamps",
        description:
          "For a distinctive look that seamlessly blends style and innovation.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fext6.webp?alt=media&token=184c9667-d2d4-4045-94b4-793106d5d1b2",
      },
    ],
  },
  {
    sub: "INTERIOR",
    title: "Wild outside. Suave inside.",
    data: "Fierce on the outside, spacious and calm inside; the new Sonet is here to sharpen your sense of comfort. Be it the Smart Pure Air Purifier with Virus & Bacteria Protection, a futuristic Digital Screen & Cluster, or front ventilated & 4-Way Power Driver’s Seats; the abundance of tech in the new Kia Sonet will put you in a state of serenity.",
    carData: [
      {
        title: "Center Fascia AC Vents",
        description:
          "Ensure optimal airflow for driver and passenger, with the center console placed within easy reach of both.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fint1.jpg?alt=media&token=6fa46d48-52db-4b88-84a7-c0c1f5b8baa8",
      },
      {
        title: "Front Ventilated Seats",
        description: "Make every drive a breeze in hot and humid conditions. ",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fint302.webp?alt=media&token=b0819cdf-8ca8-4119-a1e6-663325a38f5f",
      },
      {
        title: "Smart Pure Air Purifier with Virus and Bacteria Protection^",
        description: "Ensures you breathe the cleanest air inside.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fint401.webp?alt=media&token=dff7fff4-1758-4a11-9513-91eb7ea5afee",
      },
      {
        title: "Bose Premium 7- Speakers System",
        description:
          "Elevate your drive with the perfect beats, making each moment a musical adventure.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fint503.webp?alt=media&token=4d90356b-56ab-4d40-99a5-1fc6a8158eec",
      },

      {
        title: "4-Way Power Driver’s Seat",
        description:
          "Helps you get the perfect driving stance and maximum comfort.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fint604.webp?alt=media&token=02ba206e-1d9f-4a1e-a9df-0cacf2ba0aad",
      },
      {
        title: "26.03 cm (10.25’’) HD Touchscreen Navigation",
        description:
          "Enables you to stay in command when it comes to finding your way effortlessly.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fint6.jpg?alt=media&token=b2f9a46b-0895-40ba-be5e-292c834d4d43",
      },
      {
        title: "LED Ambient Sound Mood Lights",
        description: "Creates the perfect atmosphere for every drive. ​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F6-d.mp4?alt=media&token=4239805c-d53d-4f96-bc81-57b3d0abbe2c",
      },
      {
        title: "Full Digital Cluster with 26.04 cm (10.25’’) Color LCD MID",
        description:
          "Provides real-time information and vehicle status updates",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F7-d.mp4?alt=media&token=24baf103-66b7-4914-844d-a20c2884a613",
      },
    ],
  },
  {
    sub: "PERFORMANCE",
    title: "Power of a beast.",
    data: "At the heart of every new Sonet is an engine throbbing with power. Power that's honed by precision driving dynamics from a wide range of refined and fuel-efficient engines mated to multiple transmission options. So, choose your favorite combination, put the pedal to the metal, and let every road hear you roar.",
    carData: [
      {
        title: "Powerful Smartstream 1.0 T – GDi Petrol Engine",
        description:
          "Dominate the urban landscape with the new Sonet and its Smartstream 1.0 T-GDi Petrol Engine, offering 88 kW power and 172 Nm torque.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F2-d.webp?alt=media&token=bc25c396-ce5e-4a69-aaa7-d032c793cf59",
      },
      {
        title: "Refined 1.5 CRDi VGT Diesel Engine",
        description:
          "The new Sonet features a redefined 1.5 CRDi VGT Diesel Engine delivering 85 kW and 250 Nm torque, accompanied by a first-in-segment 6 Speed Advance AT transmission.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F3-d.webp?alt=media&token=e2c5d4d1-007a-4363-ba3d-27880fac5ff6",
      },
      {
        title: "Advanced Smartstream 1.2 Petrol Engine",
        description:
          "Experience the thrill with the advanced Smartstream 1.2 Petrol Engine of the new Sonet, providing 61 kW power and 115 Nm torque.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F2-d.webp?alt=media&token=bc25c396-ce5e-4a69-aaa7-d032c793cf59",
      },
    ],
  },
  {
    sub: "NAVIGATE WITH TRUST, EMBRACE THE UNEXPECTED",
    title: "Drive with confidence.",
    data: "With such raw power comes the responsibility to keep you and your loved ones out of harm's way. That’s why we’ve built the new Sonet with robust 15 safety features across all variants; giving you dependable safety and a calm sense of security.",
    carData: [
      {
        title: "6 Airbags as Standard",
        description:
          "Allows the car to become your shield, protecting you from every corner.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F1-d.webp?alt=media&token=ffe6ceec-7365-408c-8d9a-90030c108d75",
      },
      {
        title:
          "Electronic Stability Control (ESC), Hill Assist Control (HAC) & Vehicle Stability Management (VSM)",
        description:
          "Comes as a part of the standard safety package, making your journey safe & reliable.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Ftrust2.webp?alt=media&token=8d6dc00f-8fcb-4569-8cad-edb3596eb622",
      },
      {
        title: "Blind View Monitor (BVM)",
        description:
          "Eliminates any blind spots and surprises, giving you a more holistic view.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Ftrust3.webp?alt=media&token=19cd3bd2-3d99-45b0-9dba-737df67afac9",
      },
      {
        title: "Front and Rear Parking Sensors",
        description:
          "Make parking and safe maneuvering at tricky spots simple.ESS",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Ftrust4.webp?alt=media&token=82208b97-de23-4ebe-94b3-9ff2c3af37cd",
      },

      {
        title: "ESS (Emergency Stop Signal)",
        description:
          "Alerts the driver behind by blinking the brake lights whilst braking sharply and severely.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Ftrust5.webp?alt=media&token=ac43d589-7a74-4dbf-ae36-1b81d3b69467",
      },
      {
        title: "All Seat 3 point seatbelt with reminder",
        description:
          "Reminds you to strap in whether you’re in the front or back.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Ftrust6.webp?alt=media&token=a82b238d-0de9-45d8-b00c-8be9c8dc1418",
      },
      {
        title: "All Wheel Disc Brake",
        description:
          "Enhances braking performance, so you are always in control of any unforeseen event.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Ftrust7.webp?alt=media&token=815d93d7-0770-4293-aaea-341eeff3512b",
      },
      {
        title: "360 Degree Camera",
        description: "Keeps you aware of surroundings, at all times.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F8-d.mp4?alt=media&token=c84c6639-88ea-4792-aebb-a9a8f3cd5a5a",
      },
    ],
  },
  {
    sub: "INTUITIVE ADAS LEVEL 1",
    title: "Innovation meets safety.",
    data: "Maneuver the roads with confidence. The new Sonet is equipped with an intuitive Advance Driver Assistance System (ADAS Level 1) featuring 10 autonomous safety features that help make your drive more responsive with multiple safeguards.",
    carData: [
      {
        title: "Front Collision Warning (FCW)",
        description: "Alerts you to any unexpected obstacles ahead.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F1-d.mp4?alt=media&token=e5e21636-64c9-41b9-bb3d-475f3f93ac3b",
      },
      {
        title: "Front Collision-Avoidance Assist - Cycle(FCA – Cyclist)",
        description:
          "Warns you of imminent collision with vehicles and applies brakes.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fadas2.webp?alt=media&token=63323406-b3db-488b-8d77-8351850fc8d8",
      },
      {
        title: "Front Collision-Avoidance Assist - Cyclist(FCA – Cyclist)",
        description:
          "Warns of imminent collision with cyclist and applies brakes.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fadas3.webp?alt=media&token=73da1181-3145-40c7-be4d-2ee53f4d4c9e",
      },
      {
        title:
          "Front Collision Avoidance Assist – Pedestrian (FCA - Pedestrian)",
        description:
          "Warns you of imminent collision with pedestrians and applies brakes.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fadas3.webp?alt=media&token=73da1181-3145-40c7-be4d-2ee53f4d4c9e",
      },

      {
        title: "Lane Keep Assist (LKA)",
        description:
          "Counter steers to prevent vehicle from departing from its lane.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F5-d%20(1).mp4?alt=media&token=10205ea8-eec9-413d-9cb5-feb206345469",
      },
      {
        title: "Lane Departure Warning (LDW)",
        description:
          "Alerts the driver whenever the car is going out of its lane on either side without turn indicator input.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fadas6.webp?alt=media&token=b4aabf5a-2996-4147-a7d2-6595b6a871c8",
      },
      {
        title: "Lane Following Assist (LFA)",
        description: "Detects lanes and steers to keep you in the center.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fadas7.webp?alt=media&token=3c4d39fa-e28b-4f46-8778-f921d58b4bce",
      },
      {
        title: "Leading Vehicle Departure Alert (LVDA)",
        description: "Follows movements of the vehicle in front.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fadas8.webp?alt=media&token=eaead324-b0cf-42d1-b9e7-4324522ec612",
      },
      {
        title: "High Beam Assist (HBA)",
        description: "Adapt your car’s headlights to oncoming traffic.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fadas9.webp?alt=media&token=1a6ea59c-ad6b-4851-b65b-c254f2a8ce6f",
      },
      {
        title: "Driver Attention Warning (DAW)",
        description: "Warns you of any lapse in attention.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F10-d.avif?alt=media&token=17a6b0d5-6140-4e0b-9c8b-3ae3e7b0b665",
      },
    ],
  },
  {
    sub: "CONNECTED CAR TECHNOLOGY",
    title: "Your journey, your command.",
    data: "Untamed as it may be, the new Sonet is yours to command. Next-gen Kia Connect integrated with Alexa home-to-car connectivity, and 70+ features that let you control your vehicle through a smartphone or smartwatch.",
    carData: [
      {
        title: "OTA Map & System Update",
        description:
          "Offers latest maps and system updates conveniently via Over-the-air Technology.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F1-d%20(1).webp?alt=media&token=5d31ed0e-e25d-45b8-a90a-bacfe75b4d87",
      },
      {
        title: "Voice Controlled Window Function",
        description:
          "Lets you pull up or open your windows without taking your hands off the wheel.​",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2F2-d%20(1).webp?alt=media&token=e7af628d-bff5-433d-ad71-3e1af9bcf2f0",
      },
      {
        title: "Remote AC Control",
        description:
          "Gives you the power to set your car to the perfect temperature from anywhere.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fcar3.webp?alt=media&token=0756081a-5199-4571-b564-ab1af18fdf4e",
      },
      {
        title: "Kia Connect Skill with Amazon Alexa",
        description:
          "Helps you control your Kia from the comfort of your home.",
        media:
          "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSonet%252Fcar4.webp?alt=media&token=60a8057f-bdd1-4d8f-933a-7f4b237720a1",
      },
    ],
  },
];

const TrimData = [
  {
    title: "HTE",
    cost: "7,30,138",
    feature1: "6 Airbags",
    feature2: "ESC,HAC,BA, VSM",
    feature3: "High line tyre pressure monitor",
    feature4: "Advance 10.65cm (4.2'')Color instrument cluster",
    feature5: "Halogen Headlamps",
    feature6: "Semi Leatherette Seats with All Black Interiors",
    feature7: "Rear AC Vent",
  },
  {
    title: "HTE (O)",
    cost: "7,70,299",
    feature1: "Electric Sunroof",
    feature2: "6 Airbags",
    feature3: "ESC,HAC,BA, VSM",
    feature4: "High line tyre pressure monitor",
    feature5: "Advance 10.67cm (4.2'')Color instrument cluster",
    feature6: "Halogen Headlamps",
    feature7: "Rear AC Vent",
  },
  {
    title: "HTK",
    cost: "8,40,915",
    feature1: "6 Airbags",
    feature2: "ESC,HAC,BA, VSM",
    feature3: "R16 40.56cm(16'')Dual Tone Styled Wheels",
    feature4: "Front parking sensors",
    feature5:
      "20.32cm (8.0'')Touchscreen With Wireless Android Auto and Apple CarPlay",
    feature6: "Advance 10.67cm (4.2'')Color instrument cluster",
    feature7: "Shark fin antenna",
  },
  // {
  //   title: "HTK(O)",
  //   cost: "8,73,717",
  //   feature1: "Electric Sunroof",
  //   feature2: "Fully Automatic Temperature Control ",
  //   feature3: "Star Map Connected LED Tail",
  //   feature4: "6Airbags",
  //   feature5: "ESC, HAC, BA, VSM",
  //   feature6: "R16 40.56cm (16'')Dual tone Styled Wheels",
  //   feature7: "Front parking Sensors",
  // },
  {
    title: "HTK+",
    cost: "9,10,125",
    feature1: "Electric Sunroof",
    feature2: "Star Map LED Connected Tail Lamps",
    feature3: "Star Map LED DRLs",
    feature4: "R16 40.56cm(16*) Sporty Crystal Cut Alloy Wheels",
    feature5: "Black & Beige Semi Leatherette Seats",
    feature6: "60:40 Seat Back Split Fold Seats",
    feature7: "20.32cm (8.0'')Touchscreen with Wireless Android Auto & Apple CarPlay",
  },
  {
    title: "HTK+(O)",
    cost: "9,59,274",
    feature1: "6Airbags",
    feature2: "Electric Sunroof -G1.0T Only",
    feature3: "R16 40.56cm (16'')Crystal Cut Alloy Wheels",
    feature4: "20.32cm (8.0'')Touchscreen with Wireless Android Auto CarPlay",
    feature5: "Indigo Pear Leatherette Seats",
    feature6: "Star Map LED Connected Tail Lamps",
    feature7: "Smart key with push button start",
  },

  {
    title: "HTX",
    cost: "10,80,328",
    feature1: "6 Airbags",
    feature2: "Electric Sunroof",
    feature3: "Crown Jewel LED Headlamps",
    feature4:
      "20.32cm (8.0'')Touchscreen with Wireless Android Auto and Apple CarPlay",
    feature5: "Rear Disc Brakes",
    feature6:
      "Front Ventilated Seats-G1.0T-GDi Smartstream 7DCT and D1.5 CRDI VGT iMT/6AT",
    feature7: "Black and Beige Semi Leatherette Seats-G1.0T iMT and D1.5 MT",
  },
  {
    title: "GTX+",
    cost: "13,50,652",
    feature1: "ADAS Level1 with 10 Autonomous Features",
    feature2: "360 Degree Camera with Blind View Monitor in Cluster",
    feature3: "R16 40.65cm (16'') Sporty Crystal Cut Alloy Wheels",
    feature4: "Full Digtal Cluster with 26.04cm(10.25'')Color LCD MID",
    feature5:
      "26.03cm (10.25'')HD Touchscreen Navigation with Wired Android Auto and Apple CarPlay",
    feature6: "4-Way Power Drivers Seat",
    feature7: "Front Ventilated Seats",
  },
  {
    title: "X-Line",
    cost: "13,65,215",
    feature1: "ADAS Level1 with 10 Autonomous Features",
    feature2: "360 Degree Camera wit Blind View Monitor in Cluster",
    feature3: "R16 40.56cm (16'')Sporty Crystal Cut Alloy Wheels",
    feature4: "Full Digital Cluster with 26.04cm (10.25'')Color LCD MID",
    feature5:
      "26.03 cm (10.25”) HD Touchscreen Navigation with Wired Android Auto and Apple CarPlay",
    feature6: "4-Way Power Drivers Seat",
    feature7: "Front Ventilated Seats",
  },
];

const CircleData = [
  // {
  //   title: "Intense Red + Aurora Black Pearl",
  //   color1: "#b2001e",
  //   color2: "#151617",
  //   imgSrc:
  //     "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fson1.png?alt=media&token=d7a970de-0c56-4349-9523-b05c2cc3a96b",
  // },
  {
    title: "Glacier White Pearl + Aurora Black Pearl",
    color1: "#f4f9fb",
    color2: "#151617",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FIntense%20Red%20%2B%20Aurora%20Black%20Pearl.webp?alt=media&token=4a66adb6-959a-49e8-954c-049229197b50",
  },
  {
    title: "Gravity Grey",
    color: "#444444",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FGravity%20Greysonet.webp?alt=media&token=029afb93-a823-497d-893a-01f26fa9d1f8",
  },
  {
    title: "Aurora Black Pearl",
    color: "#151617",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FAurora%20Black%20Pearlsonet.webp?alt=media&token=7ff2edb0-13e5-42c3-ac3d-bc0909f74ccb",
  },
  {
    title: "Sparkling Silver",
    color: "#e0e0df",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FSparkling%20Silversonet.webp?alt=media&token=6dfd0c91-d62c-4cf0-80ac-4a876d2d4e84",
  },
  // {
  //   title: "Intense Red",
  //   color: "#b2001e",
  //   imgSrc:
  //     "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Sonet%2Fson6.png?alt=media&token=ce43ff4c-bc88-4dae-9aee-a0923948cc9b",
  // },
  {
    title: "Glacier White Pearl",
    color: "#f4f9fb",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FGlacier%20White%20Pearlsonet.webp?alt=media&token=0f8f18d9-c9d5-4736-bd7f-79c7b37ae625",
  },
  {
    title: "Imperial Blue",
    color: "#2b2c71",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FImperial%20Bluesonet.webp?alt=media&token=5955113b-5548-4291-a0d4-faf310f48b39",
  },
  {
    title: "Pewter Olive",
    color: "#3e493b",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/sonet%2FPewter%20Olivesonet.webp?alt=media&token=fc5901e9-706e-4b0e-bfc9-3a8f6c344331",
  },
];

const DetailInfo = [
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Book New Sonet ",
    desc: "Learn all about its wild possibilities.",
    link: "",
  },
  {
    bgColor: "#05141f",
    color: "#FFF",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/download.png?alt=media&token=9de03b22-8ba2-433e-9ff0-a78165faaf3a",
    title: "Download Brochure",
    desc: "Learn all about its wild possibilities.",
    link: "https://www.kia.com/content/dam/kia2/in/en/our-vehicles/showroom/sonet/Sonet_Wild_Reborn_Brochure_2025_Desktop.pdf",
  },
  {
    bgColor: "#FFF",
    color: "#000",
    imgSrc:
      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/calendar%20(1).png?alt=media&token=20b23e49-7a08-4369-82ae-a0277d5f2e9e",
    title: "Call us for more information",
    desc: "We'll be happy to answer all your queries. 0000000000",
    link: "tel:+919237386213",
  },
];

const FaqData = [
  {
    question: "What is the new price of the Kia Sonet after GST cut?",
    answer: "Kia Sonet starts at price of ₹7 30 138*(Ex-showroom price all India) after GST cut.",
  },
  {
    question: "How many features does the new Sonet offer in its ADAS system?",
    answer:
      "The ADAS Level 1 in the new Sonet comes with 10 autonomous features to make your journey a wild one!",
  },
  {
    question: "What kind of cluster is available in the new Sonet?",
    answer:
      "The new Sonet comes with Full Digital Cluster with 26.04 cm (10.25’’) Color LCD MID offering detailed car information.",
  },
  {
    question: "How many airbags are there in the new Sonet?",
    answer:
      "The new Sonet offers 6 Airbags (Front, Side & Curtain Airbags) standard to ensure the safety of you and your loved ones",
  },
  {
    question: "What type of sunroof comes with the new Sonet?",
    answer:
      "The new Sonet compact SUV comes with Electric Sunroof that gives you a chance to connect with the outside world",
  },

  {
    question: "What are the transmission options available in the new Sonet?",
    answer:
      "The new Sonet SUV car is available in both manual and automatic transmissions, namely 5MT, 6MT, 6iMT, 7DCT, 6AT",
  },
];

const StepData = [
  {
    title: "Signature Tiger Nose Grille",
    desc: "Elevate your style with the Signature Tiger Nose Grille, taking the untamed quotient to breathtaking new heights.",
  },
  {
    title: "R16 - 40.56 cm (16'') Sporty Crystal Cut Alloy Wheels",
    desc: "Turn heads as you prowl the streets with Crystal Cut Alloy Wheels and All Wheel Disc Brakes, giving your wheels a mesmerizing spin.",
  },
  {
    title: "Star Map LED Connected Tail Lamps",
    desc: "Drive away in bold style with Connected LED Tail Lamps, making the rear of your vehicle as distinctive as your journey.",
  },
  {
    title: "Electric Sunroof ",
    desc: "Experience a connection with the outside world through the Electric Sunroof,specially designed for compact SUV enthusiasts. ",
  },
  {
    title:
      "Full Digital Cluster with 26.04 cm (10.25'')Color LCD MID+26.03 cm (10.25'')HD Touchscreen Navigation ",
    desc: "Take command effortlessly with the 26.03cm(10.25'') Digital Cluster + 26.03 cm HD Touchscreen Audio (10.25''),allowing you to stay in command and find your way with ease.",
  },
  {
    title: "Front Ventilated Seats with 4-Way Power Driver's Seat",
    desc: "Conquer hot and humid conditions with Front Ventilated Seats and a 4-Way Power Driver's Seat,ensuring every drive is a breeze with the perfect driving stance and maximum comfort.",
  },
];

export {
  CarouselData,
  CarouselData1,
  TrimData,
  CircleData,
  DetailInfo,
  FaqData,
  StepData,
  BannerData,
  IntroData,
  InterestDealerData,
  CarBanData,
  banner2Data,
};
